import { BuildPathFromCode } from '../models/inventory/location';

/**
 * Warehouses a roll may be reprocessed from. Mirrors `VALID_REPROCESS_LOCATIONS` in
 * `ReprocessCommandService.cs`; both must stay in sync or the screen offers rolls the API rejects.
 */
export const VALID_REPROCESS_LOCATIONS: readonly string[] = ['NT.WH-FIN-1', 'NT.WH-RG-1'];

/**
 * Trims a location code to its site + warehouse pair, so a sub-location counts as its warehouse:
 * `NT.WH-FIN-1.RACK-3` resolves to `NT.WH-FIN-1`. Mirrors `GetLocationHighestWarehouse` in the API.
 */
export function getHighestWarehouse(locationCode: string | undefined): string {
  const path = BuildPathFromCode(locationCode ?? '');
  return [path.siteCode, path.warehouseCode].filter((segment) => !!segment).join('.');
}

/** A roll with no resolved location is treated as invalid: the API is the only authority on where it sits. */
export function isInValidReprocessWarehouse(locationCode: string | undefined): boolean {
  return VALID_REPROCESS_LOCATIONS.includes(getHighestWarehouse(locationCode));
}
